export default {
    general: {
        add:      'Add',
        edit:     'Edit',
        delete:   'Delete',
        cancel:   'Cancel',
        save:     'Save',
        confirm:  'Confirm',
        actions:  'Actions',
        search:   'Search',
        all:      'All',
        clear:    'Clear',
        active:   'Active',
        inactive: 'Inactive',
        sign_out:  'Sign out',
        more_info: 'More information',
        no_data:  'No data',
        never:    'Never',
        back:     'Back',
        reload:   'Reload',
        per_page: 'Rows per page',
    },
    brand: {
        product_name: 'Telecel AI',
        tagline:      'Voice & SMS',
    },
    layout: {
        open_menu:  'Open menu',
        close_menu: 'Close menu',
    },
    color_mode: {
        switch_to_light: 'Switch to light mode',
        switch_to_dark:  'Switch to dark mode',
    },
    nav: {
        group_configuration:  'Configuration',
        group_administration: 'Administration',
        dashboard:    'Dashboard',
        themes:       'Themes',
        menu:         'Menu tree',
        models:       'Model registry',
        number_rules: 'Number rules',
        phone_number_limits: 'Daily limits',
        sessions:     'Sessions',
        users:        'Users',
        settings:     'Settings',
        audit_log:    'Audit log',
    },
    settings: {
        voice:                     'Voice',
        sms:                       'SMS',
        voice_audio:               'Voice audio',
        tts_model:                 'Text-to-speech model',
        tts_model_hint:            'Synthesises the spoken IVR menu. Only active speech-synthesis models are listed. Without one, menu audio cannot be generated at all.',
        tts_voice:                 'Voice',
        tts_voice_hint:            'Which voice speaks the prompts. Audio already generated keeps the voice it was recorded with — the new one applies to whatever is synthesised next.',
        tts_model_none:            'No model selected',
        limit_prompt:             'Daily limit reached',
        limit_prompt_hint:        'What a caller hears when their daily limit is used up. Saving synthesises the audio and stores it, so the words are what the caller actually hears. Leave empty to play the generic refusal prompt instead.',
        limit_prompt_placeholder: 'You have reached your daily limit. You can continue tomorrow.',
        limit_prompt_save:        'Save and generate audio',
        limit_prompt_unsaved:     'No audio for the current wording yet — save to generate it.',
        no_tts_model:              'No speech-synthesis model registered',
        no_tts_model_hint:         'Add a model of kind "Speech synthesis" in the model registry first.',
        system_prompt:             'System prompt',
        system_prompt_hint:        'Prepended to the theme\'s own prompt at the start of every conversation on this channel. Leave empty for none.',
        system_prompt_placeholder: 'You are Telecel\'s assistant. Keep answers short and never promise a price you were not given.',
    },
    auth: {
        sign_in:                     'Sign in',
        username:                    'Username',
        password:                    'Password',
        current_password:            'Current password',
        new_password:                'New password',
        change_password:             'Change password',
        must_change_password_notice: 'You must change your password before continuing.',
        login_title:                 'Telecel AI Platform',
        login_subtitle:              'Sign in to the management portal',
        remember_me:                 'Keep me signed in',
    },
    dashboard: {
        title:   'Dashboard',
        welcome: 'Welcome, {name}',
    },
    statistics: {
        range_from:  'From',
        range_to:    'To',
        range_today: 'Today',
        range_days:  'Last {count} days',

        channel_all: 'All channels',

        sessions:            'Sessions',
        calls_with_duration: '{count} with a recorded length',
        messages:            'Messages',
        sms_parts:           'SMS parts sent',
        sms_parts_hint:      'What the operator is billed for.',
        tokens_total:        'Tokens',
        tokens_in:           'Input',
        tokens_out:          'Output',
        cost:                'Cost',
        talk_time:           'Talk time',
        avg_call:            'Average call',
        median_call:         'Median {value}',
        longest_call:        'Longest call',
        msisdn:              'Phone number',

        daily_tokens:      'Token usage per day',
        daily_tokens_hint: 'Input and output stacked — their sum is what gets billed.',

        model_tokens:   'Token usage per model',
        theme_sessions:      'Themes reached',
        theme_sessions_hint: 'Click a theme to see its sessions.',

        duration_distribution: 'Call length',

        by_hour:      'Sessions by hour of day',
        by_hour_hint: 'Across the whole period, in {zone}.',

        by_status: 'How sessions ended',

        top_numbers:      'Top {count} phone numbers',
        top_numbers_hint: 'Ranked by tokens spent, across every channel — the same budget the daily cap counts, so the channel tab does not narrow it.',

        other_group:   '+{count} more',
        deleted_group: '(deleted)',

        empty:           'No sessions in this period.',
        empty_durations: 'No call in this period recorded a length.',
        load_failed:     'Could not load the statistics.',
    },
    theme: {
        themes:          'Themes',
        add:             'Add theme',
        edit:            'Edit theme',
        key:             'Key',
        generate_key:    'Generate from the name',
        name:            'Name',
        active:          'Active',
        inactive:        'Inactive',
        status:          'Status',
        order:           'Order',
        channels:        'Channels',
        channel_voice:   'Voice',
        channel_sms:     'SMS',
        system_prompt:   'System prompt',
        voice:           'Voice',
        text_model:      'Text model (SMS)',
        text_model_delegation_hint: 'A Live voice model does no reasoning of its own — this is the model that thinks for it, and what its tokens are billed at.',
        greeting: 'Opening greeting',
        greeting_hint: 'Spoken before the caller says anything. Leave blank and the AI waits for the caller to speak first.',
        transcription_model: 'Transcription model',
        transcription_model_hint: 'Transcribes the caller for the stored transcript. Leave blank to skip it — calls still work, but the caller\'s side is not recorded.',
        realtime_model:  'Realtime model (voice)',
        confirm_delete:  'Delete theme {name}? This cannot be undone.',
        no_model:        'Not set',
        select_model:    'Select a model',
        needs_model:     'Add a model to the registry first — a theme needs one to answer with.',
    },
    menu: {
        tree:             'Menu tree',
        tree_hint:        'SMS and voice have separate trees, so an entry can be 1 on one channel and 2 on the other.',
        add_root:         'Add menu entry',
        add_child:        'Add entry inside',
        add:              'Add menu entry',
        edit:             'Edit menu entry',
        label:            'Name',
        label_hint_sms:     'Sent in the menu, numbered: "1. Avtomobilstvo".',
        label_hint_voice:   'Names the entry. Add spoken wording below only if the caller should hear a full sentence.',
        theme:            'Theme',
        theme_hint:       'Leave empty to make this a submenu that holds other entries.',
        no_theme:         'Submenu (no theme)',
        submenu:          'Submenu',
        wording_voice:      'Spoken wording',
        wording_voice_hint: 'Optional. Spoken instead of the name, for a full sentence like "For education press 3".',
        active:           'Active',
        drag:             'Drag to move',
        move_up:          'Move up',
        move_down:        'Move down',
        preview:          'Preview',
        preview_back:     '(0 back, * main menu)',
        empty:            'No menu entries yet. Add one to start building the tree.',
        needs_theme:      'Add a theme first — a menu entry needs one to point at.',
        reserved_digits:  'Numbering follows the order below — drag to renumber, then press Save order. 0 returns to the previous menu and * to the main menu, handled automatically.',
        order_unsaved:      'The new order is not saved yet',
        order_unsaved_hint: 'Drag as many entries as you like, then save. Leaving the page discards the changes.',
        order_save:         'Save order',
        order_discard:      'Discard',
        audio:             'Voice audio',
        audio_hint:        'One recording per menu level: the sentence is composed from that level\'s entries, so renaming or reordering one changes the whole level.',
        audio_greetings:   'Theme greetings',
        audio_greetings_hint: 'One recording per theme, in that theme\'s own voice. Until it is generated the AI speaks the greeting itself on every call, which costs money each time; changing the wording or the voice needs a new recording.',
        audio_regenerate:  'Regenerate audio',
        audio_generated:   'Generated {count} recordings.',
        audio_ready:       'Stored',
        audio_missing:     'Not generated',
        audio_current:     'The stored audio matches the current menu and theme greetings.',
        audio_stale:       'Some audio is out of date',
        audio_stale_hint:  'A menu level or a theme greeting has changed since the audio was generated. Press Regenerate audio to synthesise what is missing.',
        audio_no_model:    'No text-to-speech model selected',
        audio_no_model_hint: 'Choose one under Settings → Voice audio before generating recordings.',
        confirm_delete:   'Delete menu entry {label}? This cannot be undone.',
    },
    model: {
        reasoning_effort:      'Reasoning effort',
        reasoning_effort_hint: 'Reasoning tokens are billed as output and never reach the subscriber. Lower is cheaper; leave at Provider default for models that do not reason.',
        reasoning_default:     'Provider default',
        reasoning_minimal:     'Minimal',
        reasoning_low:         'Low',
        reasoning_medium:      'Medium',
        reasoning_high:        'High',
        models:          'Model registry',
        add:             'Add model',
        edit:            'Edit model',
        provider:        'Provider',
        model_id:        'Model',
        model_id_hint:   'The provider\'s own identifier, e.g. claude-opus-5.',
        kind:               'Kind',
        kind_text:          'Text',
        kind_realtime:      'Realtime voice',
        kind_live:          'Live voice',
        kind_tts:           'Speech synthesis',
        kind_transcription: 'Transcription',
        base_url:        'Base URL',
        api_key:         'API key',
        api_key_hint:    'Stored encrypted and never shown again. Leave empty to keep the current key.',
        api_key_set:     'Key ending {last4}',
        api_key_missing: 'No key',
        active:          'Active',
        status:          'Status',
        inactive:        'Inactive',
        self_hosted:     'Self-hosted',
        rate_input:      'Input rate (USD / M tokens)',
        rate_output:     'Output rate (USD / M tokens)',
        rate_audio:      'Audio rate (USD / minute)',
        rate_audio_hint: 'A Live voice layer is billed per minute of audio rather than per token. Its reasoning is billed separately, at the rates of the text model the theme delegates to.',
        rates:           'Rates',
        confirm_delete:  'Delete model {name}? This cannot be undone.',
    },
    number_rule: {
        number_rules:    'Number rules',
        add:             'Add rule',
        edit:            'Edit rule',
        pattern:         'Pattern',
        pattern_hint:    'Regular expression matched against the normalised number, e.g. ^\\+233 for all Ghanaian numbers.',
        pattern_invalid: 'Not a valid regular expression',
        action:          'Action',
        allow:           'Allow',
        deny:            'Deny',
        order:           'Order',
        order_hint:      'Lowest first. The first matching rule decides.',
        active:          'Active',
        inactive:        'Inactive',
        status:          'Status',
        description:     'Note',
        confirm_delete:  'Delete this rule? This cannot be undone.',
        deny_all_notice: 'No active rules: every number is denied. Add an allow rule to open the service.',
        test_title:      'Test a number',
        test_placeholder: '+233 20 123 4567',
        test_button:     'Test',
        test_allowed:    'Allowed',
        test_denied:     'Denied',
        test_normalised: 'Matched as {normalised}',
        test_by_rule:    'Decided by the highlighted rule',
        test_no_match:   'No rule matched, so the number is denied',
    },
    time_parser: {
        valid_units:          'Valid units: {0} (day, hour, minute, second).',
        decimals_not_allowed: 'Decimals are not allowed.',
        reformat_time:        'Reformat time',
        invalid_character:    "Only numbers and 'd', 'h', 'm', 's' units are allowed.",
        invalid_format:       'Units must be in form of <number><unit>',
        duplicated_unit:      'The unit {0} is duplicated',
    },
    phone_number_limit: {
        phone_number_limits: 'Daily limits',
        add:                 'Add limit',
        edit:                'Edit limit',
        msisdn:              'Number',
        msisdn_hint:         'Pick a number that has called, or type one. It is matched against the normalised form, e.g. +233201234567.',
        msisdn_invalid:      'Not a usable phone number',
        daily_time:          'Daily time',
        daily_tokens:        'Daily tokens',
        uncapped_hint:       'Leave at 0 for no limit',
        uncapped_time_hint:  'Leave empty for no time limit.',
        unlimited:           'Unlimited',
        active:              'Active',
        active_hint:         'Switch off to lift the limit without deleting it',
        inactive:            'Inactive',
        status:              'Status',
        description:         'Note',
        notice:              'Limits reset at midnight. A caller who runs out mid-call is disconnected, and the call is refused until the next day.',
        confirm_delete:      'Delete the limit for {msisdn}? The number becomes unlimited.',
        spend_button:        'Spend by number',
        spend_title:         'Spend by number',
        spend_description:   'The 50 numbers that burned the most tokens in the selected range.',
        spend_empty:         'No calls or conversations in the selected range.',
        spend_failed:        'Could not read the spend ranking.',
        set_limit:           'Set limit',
        tokens_spent:        'Tokens',
        sessions_count:      'Calls',
        last_seen:           'Last call',
        range_from:          'From',
        range_to:            'To',
        range_today:         'Today',
    },
    session: {
        sessions:       'Sessions',
        session:        'Session',
        channel:        'Channel',
        msisdn:         'Number',
        theme:          'Theme',
        status:         'Status',
        status_dialing: 'Dialing',
        live:           'Live',
        status_menu:    'In menu',
        status_active:  'Active',
        recording:         'Recording',
        recording_load:    'Play recording',
        recording_hint:    'The caller and the assistant on one track, as Asterisk recorded the call.',
        recording_failed:  'The recording could not be loaded',
        status_ended:   'Ended',
        status_limit_reached: 'Limit reached',
        status_failed:  'Failed',
        started_at:     'Started',
        ended_at:       'Ended',
        duration:       'Duration',
        audio_seconds:  'Billable audio',
        messages:       'Messages',
        tokens:         'Tokens',
        cost:           'Cost (USD)',
        refresh:        'Refresh',
        refresh_in:     'Refreshing in {seconds}s',
        transcript:     'Transcript',
        events:         'Events',
        external_ref:   'Channel reference',
        model:          'Model',
        current_node:   'Menu position',
        menu_root:      'Root menu',
        system_prompt:  'System prompt',
        no_sessions:    'No sessions yet. They appear here once the voice and SMS channels are live.',
        direction_in:   'From user',
        direction_out:  'From AI',
        sms_parts:      '{count} SMS parts',
    },
    user: {
        users:          'Users',
        add:            'Add user',
        edit:           'Edit user',
        name:           'Name',
        username:       'Username',
        email:          'Email',
        role:           'Role',
        active:         'Active',
        status:         'Status',
        inactive:       'Inactive',
        password:        'Password',
        repeat_password: 'Repeat password',
        last_password_change: 'Last password change',
        confirm_delete: 'Delete user {name}? This cannot be undone.',
        role_admin:     'Administrator',
        role_support:   'Support',
        role_readonly:  'Read only',
    },
    audit: {
        request_body: 'Request body',
        open_hint:    'Click an entry to see the request body it recorded.',
        loading_body: 'Loading…',
        no_body:      'This request carried no JSON body.',
        audit_log:   'Audit log',
        at:          'Time',
        user:        'Operator',
        method:      'Method',
        path:        'Path',
        status_code: 'Status',
        ip:          'IP address',
    },
    errors: {
        generic_error:     'An error occurred',
        invalid_data:      'Invalid data',
        not_found:         'Not found',
        unauthorized:      'Wrong username or password',
        forbidden:         'You do not have permission to do that',
        username_taken:    'That username is already taken',
        last_active_admin: 'This is the last active administrator and cannot be removed',
        duplicate_key:     'Another record already uses one of these values',
        model_in_use:      'This model is still assigned to a theme. Change the theme first.',
        theme_key_taken:   'Another theme already uses that key',
        model_already_exists: 'That provider, model and kind is already in the registry',
        menu_depth_exceeded: 'The menu cannot go deeper than three levels',
        menu_cycle:          'A menu entry cannot be moved inside itself',
        menu_has_children:   'Empty this submenu before deleting it',
        theme_in_use:        'This theme is still used by a menu entry. Remove it from the menu first.',
        menu_level_full:     'This menu level already has nine entries',
        tts_model_not_set:   'No text-to-speech model is configured. Set one in Settings first.',
        provider_key_rejected:      'The provider rejected this API key',
        provider_model_unavailable: 'This API key has no access to that model. Check the model name, and that the key belongs to a project that can use it.',
        on_add:            'Error while adding',
        on_edit:           'Error while updating',
        on_delete:         'Error while deleting',
    },
    success: {
        add:              'Successfully added',
        edit:             'Successfully updated',
        delete:           'Successfully deleted',
        password_changed: 'Password changed',
    },
    validation: {
        required:     'This field is required',
        email:        'Invalid email address',
        password_min: 'Password must be at least {min} characters',
        password_mismatch: 'Passwords do not match',
        password_same: 'The new password must be different',
        username:     'Letters, numbers, dot, dash and underscore only',
        theme_key:    'Lowercase letters, numbers and underscore only',
    },
}
